module.exports = __webpack_public_path__ + "static/media/ipod.92155410.png";